import React from 'react';
import { format } from 'date-fns';
import Icon from '../../../components/AppIcon';

const auditActions = {
  status_change: { icon: 'RefreshCw', color: 'text-blue-500 bg-blue-100 dark:bg-blue-900/30' },
  assignment: { icon: 'UserPlus', color: 'text-purple-500 bg-purple-100 dark:bg-purple-900/30' },
  approval: { icon: 'CheckCircle', color: 'text-emerald-500 bg-emerald-100 dark:bg-emerald-900/30' },
  rejection: { icon: 'XCircle', color: 'text-red-500 bg-red-100 dark:bg-red-900/30' },
  evidence_upload: { icon: 'Paperclip', color: 'text-amber-500 bg-amber-100 dark:bg-amber-900/30' },
  recommendation_raised: { icon: 'Plus', color: 'text-teal-500 bg-teal-100 dark:bg-teal-900/30' },
  escalation: { icon: 'AlertTriangle', color: 'text-red-500 bg-red-100 dark:bg-red-900/30' },
  default: { icon: 'Activity', color: 'text-muted-foreground bg-muted' },
};

const AuditTrailPanel = ({ auditLog }) => {
  const entries = auditLog || [
    { id: 1, action: 'assignment', user: 'Admin', detail: 'Investigation assigned to Dr. Sarah Johnson', timestamp: '2025-01-10T15:00:00' },
    { id: 2, action: 'status_change', user: 'Dr. Sarah Johnson', detail: 'Status changed: Assigned → In Progress', timestamp: '2025-01-10T15:30:00' },
    { id: 3, action: 'evidence_upload', user: 'Dr. Sarah Johnson', detail: 'Evidence uploaded: chemical_spill_photos.zip', timestamp: '2025-01-11T09:15:00' },
    { id: 4, action: 'status_change', user: 'Dr. Sarah Johnson', detail: 'Status changed: In Progress → Findings Documented', timestamp: '2025-01-12T14:00:00' },
    { id: 5, action: 'approval', user: 'Site Approver', detail: 'Investigation findings approved', timestamp: '2025-01-13T10:30:00' },
    { id: 6, action: 'recommendation_raised', user: 'Dr. Sarah Johnson', detail: 'Recommendation raised: Install chemical containment barriers', timestamp: '2025-01-13T11:00:00' },
  ];

  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center gap-2 mb-5">
        <div className="p-2 bg-slate-100 dark:bg-slate-900/30 rounded-lg">
          <Icon name="Activity" size={18} className="text-slate-600 dark:text-slate-400" />
        </div>
        <div>
          <h3 className="text-base font-semibold text-foreground">Audit Trail</h3>
          <p className="text-xs text-muted-foreground">Immutable log of all actions</p>
        </div>
      </div>

      <div className="relative">
        <div className="absolute left-4 top-0 bottom-0 w-px bg-border" />
        <div className="space-y-4">
          {entries?.map((entry, idx) => {
            const { icon, color } = auditActions?.[entry?.action] || auditActions?.default;
            return (
              <div key={entry?.id || idx} className="relative flex gap-4 pl-10">
                <div className={`absolute left-1.5 w-5 h-5 rounded-full flex items-center justify-center ${color} flex-shrink-0`}>
                  <Icon name={icon} size={11} />
                </div>
                <div className="flex-1 pb-1">
                  <p className="text-sm text-foreground leading-snug">{entry?.detail}</p>
                  <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="User" size={11} />
                      {entry?.user}
                    </span>
                    {entry?.timestamp && (
                      <span className="flex items-center gap-1">
                        <Icon name="Clock" size={11} />
                        {format(new Date(entry.timestamp), 'MMM dd, yyyy HH:mm')}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AuditTrailPanel;
